import React from "react";
import { connect } from "react-redux";
import { Link, Redirect, withRouter } from "react-router-dom";

import { validate1 } from "../actions/userActions";
import { login } from "../actions/configActions";
import { enableDebug } from "../actions/configActions";
import Button from "../components/buttons/Button";
import "./Login.css";

class Login extends React.Component {
  componentDidMount() {
    if (this.username) this.username.focus();
  }

  onLogin = event => {
    event.preventDefault();
    this.props.login(this.username.value, this.password.value);
  };

  render() {
    // TODO: If user is anonymously auto logged in and then logs out
    // he will be stuck at "Logging in...". The system should automatically
    // issue a new login request.
    if (this.props.anonymous_autologin && !this.props.isAuthenticated) {
      return <div>Logging in...</div>;
    }

    if (this.props.isAuthenticated) {
      return <Redirect to={this.props.redirectTo} />;
    }

    if (this.props.debug === true) {
      this.props.enableDebug();
    }

    return (
      <main>
        {this.props.debug === true ? (
          <div className="alert alert-success" role="alert">
            {this.props.text("login.debug")}
          </div>
        ) : (
          ""
        )}

        {this.props.error ? (
          <div className="alert alert-danger" role="alert">
            {this.props.text("login.loginfailed")} ({this.props.error})
          </div>
        ) : (
          ""
        )}

        {!this.props.webrtc && !this.props.temasys ? (
          <div className="alert alert-danger" role="alert">
            {this.props.text("login.nowebrtc")}
          </div>
        ) : (
          ""
        )}

        <h1>{this.props.text("common.appName")}</h1>

        {this.props.anonymous_enabled && (
          <div>
            <h2>{this.props.text("login.loginanonymous.headline")}</h2>
            <Button
              type="button"
              className="login-button"
              onClick={() =>
                this.props.login(
                  this.props.anonymous.user,
                  this.props.anonymous.password
                )
              }
              text={this.props.text("login.loginanonymous")}
              icon={this.props.config.anonymous.icon}
            />
          </div>
        )}

        {this.props.authenticated_enabled && (
          <form onSubmit={this.onLogin} className="margin-top-3em">
            <h2 id="h1id">{this.props.text("login.headline")}</h2>

            {this.props.text("xlogin.optinalLoginInfo") !==
              "?xlogin.optinalLoginInfo" && (
              <div className="margin-bottom-1em">
                <strong>
                  <a
                    className="underlined"
                    href={this.props.text("login.optinalLoginInfoLink")}
                  >
                    {this.props.text("login.optinalLoginInfo")}
                  </a>
                </strong>
              </div>
            )}
            {this.props.text("login.optinalLoginInfo") !==
              "?login.optinalLoginInfo" && (
              <div className="margin-bottom-1em">
                <strong>
                  {this.props.text("login.optinalLoginInfo")}
                </strong>
              </div>
            )}

            <div className="form-group">
              <label htmlFor="username" className="font-weight-bold">
                {this.props.text("common.username")}
              </label>
              <input
                required={true}
                aria-required="true"
                type="text"
                name="username"
                className="form-control"
                id="username"
                ref={obj => {
                  this.username = obj;
                }}
                placeholder={this.props.text("common.username")}
                onChange={this.onChange}
              />
            </div>
            <div className="form-group">
              <label htmlFor="password" className="font-weight-bold">
                {this.props.text("common.password")}
              </label>
              <input
                required={true}
                aria-required="true"
                type="password"
                name="password"
                autoComplete="off"
                className="form-control"
                id="password"
                ref={obj => {
                  this.password = obj;
                }}
                placeholder={this.props.text("common.password")}
                onChange={this.onChange}
              />
            </div>

            <Button
              type="submit"
              className="login-button"
              text={this.props.text("login.login")}
            />
          </form>
        )}

        {this.props.config.mode.registration_enabled && (
          <div className="margin-top-3em">
            <strong>
              <Link className="underlined" to={"/registration"}>
                {this.props.text("login.registration")}
              </Link>
            </strong>
          </div>
        )}

        {this.props.text("login.optinalLogin") !== "?login.optinalLogin" && (
          <div className="margin-top-1em">
            <strong>
              <a
                className="underlined"
                href={this.props.text("login.optinalLoginLink")}
              >
                {this.props.text("login.optinalLogin")}
              </a>
            </strong>
          </div>
        )}

        {this.props.text("login.optinalLogin2") !== "?login.optinalLogin2" && (
          <div className="margin-top-1em">
            <strong>
              <a
                className="underlined"
                href={this.props.text("login.optinalLoginLink2")}
              >
                {this.props.text("login.optinalLogin2")}
              </a>
            </strong>
          </div>
        )}

        {this.props.text("login.handleData") !== "?login.handleData" && (
          <div className="margin-top-1em">
            <strong>
              <a
                className="underlined"
                href={this.props.text("login.handleDataLink")}
              >
                {this.props.text("login.handleData")}
              </a>
            </strong>
          </div>
        )}

        {this.props.config.mode.resetpassword_enabled && (
          <div className="margin-top-1em">
            <strong>
              <Link className="underlined" to={"/resetpassword"}>
                {this.props.text("login.resetpassword")}
              </Link>
            </strong>
          </div>
        )}
      </main>
    );
  }
}

const mapStateToProps = (state, props) => {
  const redirectTo = props.location.state ? props.location.state.from : "/";

  return {
    config: state.config,
    error: state.user.loginerror,
    loginform: state.user.loginform,
    text: state.config.text,
    anonymous_enabled: state.config.mode.anonymous_enabled,
    authenticated_enabled: state.config.mode.authenticated_enabled,
    anonymous_autologin: state.config.mode.anonymous_autologin,
    anonymous: state.config.anonymous,
    webrtc: state.config.webrtc,
    temasys: state.config.temasys,
    isAuthenticated: state.user.authenticated,
    redirectTo: redirectTo,
  };
};

const mapDispatchToProps = (dispatch, state) => {
  return {
    login: (username, password) => {
      dispatch(login(username, password));
    },
    validate: (username, password) => {
      dispatch(validate1(username, password));
    },
    enableDebug: () => {
      dispatch(enableDebug());
    },
  };
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Login));






// WEBPACK FOOTER //
// ./src/containers/Login.js